import React, {useContext, useEffect} from "react";
import { observer } from "mobx-react-lite";
import { Breadcrumb, BreadcrumbItem, Card, CardBody, Col, Container, Row } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { StateContext } from "../../App";
import Header from "../../components/Header";
import { RouterLink } from "mobx-state-router";
import CreateMediaFileForm from "../../components/mediaFiles/create/CreateMediaFileForm";

const CreateMediaFileHome = observer(() => {
  const stateContext = useContext(StateContext);
  const createMediaFileState = stateContext.rootUiStore.createMediaFileState

  return (
    <Container fluid>
      <Header>
        <Breadcrumb>
          <BreadcrumbItem>
            <RouterLink routeName="dashboard"><FormattedMessage id="routes.home.defaultMessage"/></RouterLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <RouterLink routeName="mediaFiles">Media Files</RouterLink>{/*<FormattedMessage id="routes.utm.defaultMessage"/>*/}
          </BreadcrumbItem>
          <BreadcrumbItem active> <FormattedMessage id="routes.createNew.defaultMessage"/></BreadcrumbItem>
        </Breadcrumb>
      </Header>
      <Row>
        <Col >
          <Card>
            <CardBody>
              <CreateMediaFileForm createMediaFileState={createMediaFileState}/>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
})

export default CreateMediaFileHome;
